// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"PermisosTable_spinnerContainer__a4Gd3","botonAdd":"PermisosTable_botonAdd__UEgaS"};